"use strict";
exports.__esModule = true;
exports.WebsdkQuotationService = void 0;
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var websdk_quotation_helper_service_1 = require("./websdk-quotation-helper.service");
var utils_1 = require("../../core/websdk/utils");
var getNightQuotation = function (params) {
    return rxjs_1.from(websdk_quotation_helper_service_1.WebsdkQuotationHelperService.fetchQuotation(params)).pipe(operators_1.map(function (res) { return res.data[0]; }), operators_1.map(function (data) {
        return {
            price: data === null || data === void 0 ? void 0 : data.pricePerNight,
            currencyHtml: (data === null || data === void 0 ? void 0 : data.currency_html) || (data === null || data === void 0 ? void 0 : data.currency),
            nights: (data === null || data === void 0 ? void 0 : data.nights) || 1
        };
    }), operators_1.catchError(function (err) {
        utils_1.dispatchErrorEvent(err);
        return rxjs_1.of(err);
    }));
};
exports.WebsdkQuotationService = { getNightQuotation: getNightQuotation };
//# sourceMappingURL=websdk-quotation.service.js.map